<script lang="ts">
  import { css } from '@agapi/ui/panda/css';
  import { textFieldStyles } from './text-field.styles';
  import type { TextFieldProps } from './text-field.types';

  let {
    label,
    name,
    type = 'text',
    value = $bindable(),
    placeholder,
    required = false,
    hideLabel = false,
    success = false,
    error = false,
    disabled = false,
    maxLength,
    helperText,
    ariaLabel,
    leadingIcon,
    trailingIcon,
    rootStyles,
    floatingLabel = false,
    labelStyles,
    iconStyles,
    inputStyles,
    helperStyles,
    ref = $bindable<HTMLInputElement>(),
    ...props
  }: TextFieldProps = $props();

  const classes = $derived(textFieldStyles.raw({
    hideLabel,
    success,
    error,
    floatingLabel,
    leadingIcon: leadingIcon !== undefined,
    trailingIcon: trailingIcon !== undefined,
    disabled
  }));


  function handleChange(e: any) {
    value = e.target.value;
  }
</script>

<div class={css(classes.root, rootStyles)}>
  <div style="position: relative">
    {#if leadingIcon}
      <div class={css(classes.icon, iconStyles)}>
        {@render leadingIcon()}
      </div>
    {/if}

    <input
    {...props}
    class={css(classes.input, inputStyles)}
    {name}
    {type}
    {required}
    {placeholder}
    {value}
    {disabled}
    aria-label={ariaLabel || label}
    oninput={handleChange}
    bind:this={ref}
    />
    <label class={css(classes.label, labelStyles)} for={name}>
      <span style="font-weight: bold; line-height: none;">
        {label}
      </span>
    </label>
    {#if trailingIcon}
      <div class={css(classes.icon, iconStyles, { right: 0 })}>
        {@render trailingIcon()}
      </div>
    {/if}
  </div>

  {#if helperText}
    <div class={css(classes.helper, helperStyles)}>
        {helperText}
    </div>
  {/if}
</div>
